import $ from 'jquery';
// import prestashop from 'prestashop';

var DoubleAddToCartProtection = {
    lock: function (addToCartClassName) {
        $(addToCartClassName).attr('disabled', true);
        console.log('theme: add to cart locked');
        
        setTimeout(function () {
            DoubleAddToCartProtection.unLock('.add .add-to-cart');
        }, 5000);
    },
    unLock: function (addToCartClassName) {
        $(addToCartClassName).attr('disabled', false);
        console.log('theme: add to cart unlocked');
    },
}

// var cartLock = function (addToCartClassName) {
//   $(addToCartClassName).attr('disabled', true);
//   console.log('theme: add to cart locked');
  
//   setTimeout(function () {
//     cartUnLock('.add .add-to-cart');
//   }, 1000);
  
// };

// var cartUnLock = function (addToCartClassName) {
//   $(addToCartClassName).attr('disabled', false);
//   console.log('theme: add to cart unlocked');
// };


$(document).ready(() => {
    $('#main').on('click', '[data-button-action="add-to-cart"]', (event) => {
    
        console.log('theme: add to cart start');
        setTimeout(function(){
            DoubleAddToCartProtection.lock('.add .add-to-cart');
        }, 5);
        return true;
    });
});



// WEBPACK FOOTER //
// ./modules/double-add-to-cart-click-protection/js/double-add-to-cart-click-protection.js